<script setup>
/**
 * The status marker on a settings card or choice card - `Connected`, `Active`,
 * `Coming soon`, `Enterprise only`.
 *
 * Distinct from the sidebar's `SidebarStatePill`, which is bare coloured text
 * sized for a dense nav column; these carry a tint because they sit alone in a
 * card header where they are the only status signal.
 */
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  tone: {
    type: String,
    default: 'neutral',
    validator: value =>
      ['success', 'info', 'neutral', 'upgrade', 'alert'].includes(value),
  },
  icon: { type: String, default: '' },
});

const TONES = {
  success: 'text-n-teal-11 bg-n-teal-3',
  info: 'text-n-blue-11 bg-n-blue-3',
  neutral: 'text-n-slate-11 bg-n-alpha-2',
  alert: 'text-n-ruby-11 bg-n-ruby-3',
  upgrade: 'text-n-blue-11 bg-n-blue-3',
};

const toneClass = computed(() => TONES[props.tone]);
</script>

<template>
  <span
    class="inline-flex items-center flex-shrink-0 gap-1 px-2 py-0.5 text-xs font-medium rounded-md"
    :class="toneClass"
  >
    <span v-if="icon" :class="icon" class="size-3.5" />
    {{ label }}
  </span>
</template>
